import IDocumentService from "../../spi/IDocumentService";
import IDocument, { IDocumentSecurityType, IDocumentFilter, IDocumentCollection, convertToDoc } from "../../../types/IDocument";
import FirebaseService from "./FirebaseService";
import Firebase from "../../Firebase";
import axios from 'axios';
import ElasticSearchService from "../elastic/ElasticSearchService";
import IPaginator, { IPaginatorQueryType, IFirebasePaginatorOperation } from "../../../types/Paginator";
import IActivity, { IActivityCollection, convertToActivity } from "../../../types/IActivity";
import { getCurrentTenant } from '../../../configs/dbConfigs' 
import ITenant from "../../../types/ITenant";

const TENANT:ITenant = getCurrentTenant();


export default class FirebaseDocumentService implements IDocumentService {
    async getDocuments( pg:IPaginator, filter?: IDocumentFilter): Promise<IDocumentCollection> {
        let paginator = pg == null ? {
            type: filter == null ? IPaginatorQueryType.Firebase : IPaginatorQueryType.Elastic,
            totalPages: 0,
            pageNumber: 0,
            rowsPerPage: 6
        } : pg;
        let collection:IDocumentCollection = {
            documents: [],
            paginator: pg
        };
        
        try {
            
            if(paginator.type == IPaginatorQueryType.Elastic){
                 //search
            //     const searchResults = await new ElasticSearchService().searchDocuments(paginator.rowsPerPage, paginator.pageNumber, filter);
                
            //     if(searchResults && searchResults.data){
            //         const hitsArray:any = searchResults.data.hits.hits;
            //         const totalHits:number = searchResults.data.hits.total;
            //         hitsArray.forEach((hit:any)=>{
            //             const rawDoc:any = hit._source;
            //             const _id:any = hit._id;
            //             // const document:IDocument = this._getIDocument(_id, rawDoc.owner, rawDoc.coverTemplate, rawDoc);
            //             const document:IDocument = convertToDoc(rawDoc);
            //             document.uid = _id;
            //             collection.documents.push(document);
            //         });
            //         collection.paginator= {
            //             type: IPaginatorQueryType.Elastic,
            //             totalPages: Math.ceil(totalHits /paginator.rowsPerPage),
            //             pageNumber: paginator.pageNumber,
            //             rowsPerPage: paginator.rowsPerPage,
            //         };
            //     }
            } else {
                let snapshot:any = null;
                if(paginator.fbOperation == IFirebasePaginatorOperation.Next){
                    snapshot = await FirebaseService.getInstance()
                    .documents()
                    .orderBy("name", "asc")
                    .startAt(paginator.nextCursor)
                    .limit(paginator.rowsPerPage)
                    .get();
                }else if (paginator.fbOperation == IFirebasePaginatorOperation.Prev){
                    snapshot = await FirebaseService.getInstance()
                    .documents()
                    .orderBy("name", "desc")
                    .startAt(paginator.prevCursor)
                    .limit(paginator.rowsPerPage)
                    .get();
                }else {
                    snapshot = await FirebaseService.getInstance()
                    .documents()
                    .orderBy("name", "desc")
                    .limit(paginator.rowsPerPage)
                    .get();
                }

                if(!snapshot.empty){
                    snapshot.forEach((child:any, i:number) => {
                        const key = child.id;
                        const doc = child.data();
                        doc.uid = key;
                        //const document:IDocument = this._getIDocument(key, owner, coverTemplate, doc);
                        const document:IDocument = convertToDoc(doc);
                        collection.documents.push(document);
                        if(i==0){
                            paginator.prevCursor = child
                        }
                        paginator.nextCursor = child;
                    });
                    collection.paginator = {
                        totalPages: 0,
                        pageNumber: 0,
                        rowsPerPage: paginator.rowsPerPage,
                        type: IPaginatorQueryType.Firebase,
                        prevCursor: paginator.prevCursor,
                        nextCursor: paginator.nextCursor
                    }
                    
                }   
            }
        }catch(e){;
            console.log(e)
            throw e;
        }
        
        return collection;
    }

    async getDocumentActivities(uid: string, pg: IPaginator): Promise<IActivityCollection> {
        let collection: IActivityCollection = {
          activities: [],
          paginator: pg
        };
    
        try {
          const snapshot = await FirebaseService.getInstance()
            .documents().doc(uid).collection('activities')
            .orderBy("time", "desc")
            //.startAt(paginator.nextCursor )
            .limit(pg.rowsPerPage)
            .get();
          if (!snapshot.empty) {
            snapshot.forEach((child: any, i: number) => {
              const key = child.id;
              const act = child.data();
              act.uid = key;
              //const document:IDocument = this._getIDocument(key, owner, coverTemplate, doc);
              const activity: IActivity = convertToActivity(act);
              collection.activities.push(activity);
              if (i == 0) {
                pg.prevCursor = child
              }
              pg.nextCursor = child;
            });
            collection.paginator = {
              totalPages: 0,
              pageNumber: 0,
              rowsPerPage: pg.rowsPerPage,
              type: IPaginatorQueryType.Firebase,
              prevCursor: pg.prevCursor,
              nextCursor: pg.nextCursor
            }
          }
    
        } catch (e) {
          throw e;
        }
    
        return collection;
      }

    /*private _getIDocument(key:any, owner:any, coverTemplate:any, doc:any):IDocument {
        const autoDoc:IDocument = convertToDoc(doc);
        return {
            uid: key,
            fileName: doc.fileName,
            name: doc.name,
            extension: doc.extension,
            docUrl: doc.docUrl,
            handle: doc.handle,
            mimeType: doc.mimeType,
            noOfPages: doc.noOfPages,
            size: doc.size,
            status: doc.status,
            thumbUrl: doc.thumbUrl,
            category: doc.category,
            description: doc.description,
            shareable: doc.shareable,
            isActive: doc.isActive,
            contentType: doc.contentType,
            customerStage: doc.customerStage,
            readTime: doc.readTime,
            dimension: {
                width: doc.dimension ? doc.dimension.width : null,
                height: doc.dimension ? doc.dimension.height : null
            },
            tags: doc.tags ? doc.tags.map((t:string)=> {return t}): [],
            pages: doc.pages ? doc.pages.map((p:any, i:number)=> {
                return {
                    id: i,
                    url: p.url
                }
            }) : [],
            who: {
                createdOn: doc.createdOn,
                owner: doc.owner ? {
                    uid: owner.uid,
                    displayName: owner.displayName,
                    imageUrl: owner.imageUrl
                } : {
                    uid: '',
                    displayName: '',
                    imageUrl: ''
                }
            },
            coverTemplate: coverTemplate ? {
                uid: coverTemplate.uid ? coverTemplate.uid : '',
                title: coverTemplate.title ? coverTemplate.title : '',
            }: {
                uid: '',
                title: ''
            },
            thumbPageNo: doc.thumbPageNo ? doc.thumbPageNo : 1,
            conversionStatus: doc.conversionStatus ? doc.conversionStatus : "completed"
        }
    }
    */
    async getDocument(docId: string): Promise<IDocument> {
        let document:IDocument = {} as IDocument;
        try{
            const snapshot = await FirebaseService.getInstance()
                                .document(docId)
                                .get();            
            const doc:any = snapshot.data();
            const key:string = snapshot.id;
            doc.uid = key;
            document = convertToDoc(doc);
        }catch(e){
            throw e;
        }
        return document;
    }

    _decodeSecurity(security: string):IDocumentSecurityType {
        let type: IDocumentSecurityType = "" as IDocumentSecurityType;
        if(security == null || security == "")
            type = IDocumentSecurityType.None
        else if(security == 'Public')
            type = IDocumentSecurityType.Public
        else if(security == 'Private')
            type = IDocumentSecurityType.Private

        return type;
    }

    async createDocument(doc: IDocument): Promise<IDocument> {
        let document:IDocument = {} as IDocument;
        try{
            const { uid, ...documentSnapshot } = doc;
            await FirebaseService.getInstance().documents().add(documentSnapshot)
                        .then((ref:any) => {
                            doc.uid = ref.id
                        });
            document = doc;
        }catch(e){
            throw e;
        }
        // return document;
        return doc
    }
    
    async updateDocument(doc: IDocument): Promise<IDocument> {
        let document:IDocument = {} as IDocument;
        try{
            const { ...documentSnapshot } = doc;
            if(doc.uid != null){
                await FirebaseService.getInstance()
                                .document(doc.uid)
                                .update({
                                    ...documentSnapshot
                                });
                document = doc;
            }
        } catch(e){
            throw e;
        }

        return document;
    }
    
    async deleteDocument(uid: string): Promise<boolean> {
        try{
            if(uid != null)
                await FirebaseService.getInstance().documents().doc(uid).delete()
                //TODO: delete file from storage as well.
        }catch(e){
            throw e;
        }
        return true;
    }

    async createShareableLink(shareObject: any): Promise<any> {
        let shareCode = "";
        try {
            shareCode = await FirebaseService.getInstance().database().ref().child('sharecodes').push().key;
            FirebaseService.getInstance().sharecode(shareCode).set(shareObject);
        }catch(e){
            throw e;
        }
        return shareCode;
    }

    async getSharedDocument(sharecode: any): Promise<any> {
        let sharecodeObj = {} as IDocument;
        try {
            const snapshot =  await FirebaseService.getInstance()
                                .sharecode(sharecode)
                                .get();
            const obj:any =  snapshot.data();
            sharecodeObj = await this.getDocument(obj.docUid);
        }catch(e){
            throw e;
        }
        return sharecodeObj;
    }

    async shareDocument(obj: any): Promise<any> {
        let response:any = "";
        try {
            response = await FirebaseService.getInstance().share(obj);
        }
        catch(e) {
            throw e;
        }
        return response
    }

    async pushToQueue(obj: any): Promise<any> {
        let response:any = "";
        obj['topic'] = 'projects/og-ordertest/topics/document-queue';
        obj['message']['tenantId'] = 'tenant_'+TENANT.tenantId;
        obj['message']['collection'] = 'SALESPLAYAPP';

        try {
            response = await FirebaseService.getInstance().pushToQueue(obj);
        }
        catch(e) {
            throw e;
        }
        return response
    }
}